module.exports = "textarea {\r\n  height: 200px;\r\n  resize: none;\r\n}\r\n\r\n:host ::ng-deep .ck-editor__editable_inline {\r\n  height: 130px !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/add-an-event-email/add-an-event-email.component.css
// module id = ./src/app/shared/components/add-an-event-email/add-an-event-email.component.css
// module chunks = main